import uuid from 'uuid/v4';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

import { MAP_CONTEXTS } from '@Pages/Hopinto/constants';
import { setFullTextDocumentId } from './FullTextResults';
import { _resolveAuth, _goToQuickSearch, _goToAdvancedSearch } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const resolveFullText = _resolveAuth(async function resolveFullText({ query, context, origin }) {
  try {
    const fullTextDocumentIdMatches = /\w+\.\w+\s*=\s*'?(\d+)'?/gi.exec(query);
    const fullTextDocumentId = fullTextDocumentIdMatches && fullTextDocumentIdMatches[1];

    const queryFactItem = await MessageBroker.send(RequestUrls.hopInto, { query, context, origin });

    if (fullTextDocumentId) {
      setFullTextDocumentId(fullTextDocumentId);
    } else {
      Logger.error('Hopinto/FullText - document id could not be parsed from query', query);
    }

    const request = {
      context: MAP_CONTEXTS[context] || context,
      queryFactItem,
      searchId: uuid(),
    };

    _goToAdvancedSearch({
      importedQuery: request,
      autoSearch: 'hopInto',
    });
  } catch (e) {
    _goToQuickSearch();
  }
});
